import React from 'react';
import { useIntl } from 'umi';
import type { SpaceProps} from "antd";
import { Space, Spin } from "antd";
import ProDescriptions from "@ant-design/pro-descriptions";

import type { ServiceItem } from "@/pages/Service/Services/components/ServiceItem/data";
import type { ServiceTask, ServiceTaskProcessorType} from "@/pages/TaskView/BatchCreateTask/data.d";
import { ServiceTaskProcessorTypeEnum } from "@/pages/TaskView/BatchCreateTask/data.d";
import styles from './index.less';

type TaskSummaryProps = {
  taskInfo?: ServiceTask;
  style?: React.CSSProperties;
};

const { Item } = ProDescriptions;

export const serviceItemNames = (serviceItems?: ServiceItem[], spaceProps?: SpaceProps): React.ReactNode => {
  return serviceItems && serviceItems.length
    ? <Space size={0} split="，">
        {
          serviceItems.map(item => (
            <span key={item.id}>{item.name}</span>
          ))
        }
      </Space>
    : <span>/</span>
};

export const processorHandler = (info?: any, processorType?: ServiceTaskProcessorType): React.ReactNode => {
  if (info && info.org) {
    return (
      processorType === ServiceTaskProcessorTypeEnum['团队']
        ? <span>{info.org || '/'}</span>
        // : <Space split=" | ">
        //     <span>{info.name || '/'}</span>
        //     <span>{info.org || '/'}</span>
        //   </Space>
        : <span>{info.name || '/'} | {info.org || '/'}</span>
    );
  } else {
    return <span>/</span>
  }
};

const TaskSummary: React.FC<TaskSummaryProps> = ({ taskInfo, style }) => {
  // 国际化
  const intl = useIntl();
  // const t = window.$tc('pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary', intl.formatMessage);
  const c = window.$tc('src.pages.TaskView.TaskProcess.components.TaskDetail.TaskSummary', intl.formatMessage);

  return (
    <Spin spinning={!taskInfo}>
      <ProDescriptions column={3} className={styles.proDesc} style={{...style}}>
        <Item span={3} label={c('c1', '服务项目')}>
          {serviceItemNames(taskInfo?.serviceItems)}
        </Item>
        <Item label={c('c2', '任务来源')}> 
          {taskInfo?.dataSource}
        </Item>
        <Item label={c('c3', '任务创建者')}>
          {processorHandler(taskInfo?.createUserInfo)}
        </Item>
        <Item label={c('c4', '任务转交者')}>
          {processorHandler(taskInfo?.moveUserInfo)}
        </Item>
        <Item label={c('c5', '实际执行者')}>
          {processorHandler(taskInfo?.handlerInfo)}
        </Item>
        <Item label={c('c6', '实际执行时间')} span={2}>
          <span>{taskInfo?.processTimeB || '/'}</span>
        </Item>
        <Item label={c('c7', '计划执行者')}>
          {processorHandler(taskInfo?.processorInfo, taskInfo?.processorType)}
        </Item>
        <Item label={c('c8', '计划执行时间')} span={2}>
          <Space split=" ~ ">
            <span>{taskInfo?.planningTimeB}</span>
            <span>{taskInfo?.planningTimeE}</span>
          </Space>
        </Item>
        <Item label={c('c9', '任务描述')} span={3}>
          <div>
            {
              taskInfo?.desc?.split("\n")?.map((item:string) => {
                return <div>{item}</div>;
              })
            }
          </div>
          
        </Item>
      </ProDescriptions>
    </Spin>
  )
};

export default TaskSummary;
